<template>
    <v-navigation-drawer
      v-model="show"
      absolute
      temporary
      height="100%"
      color="primary"
      width="100%"
    >
        <v-row
            align="center"
            justify="center"
            class="job-links pa-0"
        >
            <v-col
                cols="6"
                sm="6"
                md="6"
                lg="6"
                v-for="(module, index) in modules"
                :key="`mod-${index}`"
                class="pa-0"
            >
                <v-card
                    class="single-module d-flex flex-wrap justify-center align-content-center"
                    light
                    outlined
                    color="#1565c0"
                    tile
                    :href="module.link"
                    target="_blank"
                    v-if="module.title == 'Task Sheet'"
                >
                    <v-card-title class="pt-4 pb-0 justify-center">    
                        <v-icon
                            large
                            color="secondary"
                        >
                            {{ module.icon }}
                        </v-icon>                         
                    </v-card-title>
                    <v-card-text class="text-center">
                        <span class="subtitle-1 font-weight-bold white--text text-uppercase">{{ module.title }}</span>
                    </v-card-text>
                </v-card>
                <v-card
                    class="single-module d-flex flex-wrap justify-center align-content-center"
                    light
                    outlined
                    color="#1565c0"
                    tile
                    :to="module.link"
                    v-else
                >
                    <v-card-title class="pt-4 pb-0 justify-center">    
                        <v-icon
                            large
                            color="secondary"
                        >
                            {{ module.icon }}
                        </v-icon>                         
                    </v-card-title>
                    <v-card-text class="text-center">
                        <span class="subtitle-1 font-weight-bold white--text text-uppercase">{{ module.title }}</span>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </v-navigation-drawer>
</template>

<script>
  export default {
    props: ['show'],
    data: () => ({
        group: null,
        modules: [
            {
                title: 'Calendar',
                icon: 'mdi-calendar-month-outline',
                link: '/calendar'                     
            },
            {
                title: 'Jobs',
                icon: 'mdi-check-all',
                link: '/jobs'                     
            },
            {
                title: 'Workorders',
                icon: 'mdi-checkbox-marked-outline',
                link: '/workorders'                      
            },
            {
                title: 'Leads',
                icon: 'mdi-account-switch',
                link: '/leads'                      
            },
            {
                title: 'Customers',
                icon: 'mdi-account',
                link: '/customers'                    
            },
            {
                title: 'Reports',
                icon: 'mdi-chart-line',
                link: '/reports'                    
            },
            {
                title: 'Task Sheet',
                icon: 'mdi-file-tree',
                link: 'https://docs.google.com/spreadsheets/d/1yIpMNOhAbrGryOxlfl3RDIl89p0EPsy2YcNBKEvrUmE/edit?usp=sharing'                    
            },                     
        ]
    }),
    created() {

    },
    watch: {
        group(newVal) {
            this.$emit('update-drawer', newVal)
        },
        show(newVal) { // watch it
            this.$emit('update-drawer', newVal)
        },
    },
    methods: {

    }
  }
</script>

<style lang="sass">
.v-navigation-drawer--bottom
    &.v-navigation-drawer--is-mobile 
        max-height: 100%!important

.v-navigation-drawer
    .single-module  
        min-height: calc((100vh - 112px) / 6)
</style>